import type { NextPage } from 'next'
import styles from '../../styles/event/Event.module.scss'
import { getDay, getMonth, getRecurringStartDate } from 'helpers/event'
import { Event } from 'types/event'
import { isDev } from 'app/general'

interface Props {
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
  buttons?: JSX.Element
  day?: string
  month?: string
  image?: string
  hideDate?: boolean
}
const EventImageComponent: NextPage<Props> = (props: Props) => {

  return (
    <div className={styles.imageWrapper} onClick={props.onClick}>
      <img src={props.image} className={styles.image} />
      {!props.hideDate &&
        <div className={styles.date}>
          <div className={styles.day}>
            {props.day}
          </div>
          <div className={styles.month}>
            {props.month}
          </div>
        </div>
      }
      {props.buttons && <div className={styles.buttonSection}>
        {props.buttons}
      </div>
      }
    </div>
  )
}

export default EventImageComponent
